<template>
  <div id="programList">
    <div class="common_top_wrap">
      <div class="common_tit">프로그램 소개</div>
      <div class="common_search_wrap">
        <select v-model="searchParams.searchType">
          <option value="">교육과정 선택</option>
          <option value="P01">특강</option>
          <option value="P02">역량강화</option>
          <option value="P03">생애설계</option>
        </select>
        <input type="text" v-model="searchParams.searchText" placeholder="강좌명 입력"/>
        <div class="btn_search" @click="search(1)">검색</div>
      </div>
    </div>
    <div class="program_list_wrap">
      <div class="no_list_data" v-if="list.length <= 0">검색 결과가 없습니다.</div>
      <div class="program_item" :key="'program_' + item.programPid" v-for="item in list" @click="showProgram(item)">
        <div class="top">
          <img :src="'/upload/programPost/' + item.thumbnail" v-if="item.thumbnail != null" alt="프로그램 소개 썸네일 이미지"/>
          <img src="../../assets/common/default_thumbnail.png" v-else alt="프로그램 소개 기본 썸네일"/>
<!--          <div>무료</div>-->
        </div>
        <div class="tit multiline_ellipsis">{{item.subject}}</div>
        <div class="line"></div>
        <div class="bottom">
          <div class="green" v-if="item.status === 'recruit'">모집 중</div>
          <div class="black" v-if="item.status === 'done'">마감</div>
          <div class="yellow" v-if="item.status === 'ready'">대기</div>
          <div>{{item.recruitStart}} ~ {{item.recruitEnd}}</div>
        </div>
      </div>
    </div>
    <div class="list_bottom_wrap">
      <div class="btn_bottom" @click="addProgram" v-if="!isMobile && this.mySession != null && this.mySession.userPid != null && this.mySession.userRole != null">작성</div>
      <div class="common_page_wrap">
        <paginate
          v-model="pageParams.page"
          :pageCount="pageParams.totalPage"
          :clickHandler="search"
          :prevText="'<'"
          :nextText="'>'"
          :containerClass="'page_wrap'">
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import program from '../../script/program'
import common from '../../script/common'

export default {
  data () {
    return {
      isMobile: common.detectMobile(),
      // Common
      mySession: {},
      // Search
      searchTypeList: [],
      searchParams: {
        searchType: '',
        searchText: ''
      },
      // List
      filter: {
        page: 1,
        size: this.isMobile ? 4 : 6
      },
      list: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 1,
        size: this.isMobile ? 4 : 6
      }
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
      }
    })
    if (this.$route.params != null && this.$route.params.searchParams != null) {
      this.searchParams = this.$route.params.searchParams
      this.search(1)
    } else {
      this.search(1)
    }
  },
  methods: {
    search (page) {
      this.filter = {
        page: page,
        size: this.isMobile ? 4 : 6
      }
      delete this.filter['programType']
      if (this.searchParams.searchType != null && this.searchParams.searchType.length > 0) {
        this.filter['programType'] = this.searchParams.searchType
      }
      delete this.filter['search']
      if (this.searchParams.searchText != null && this.searchParams.searchText.length > 0) {
        this.filter['search'] = this.searchParams.searchText
      }
      this.updateList()
    },
    updateList () {
      program.getProgram(this.filter, response => {
        console.log('프로그램 목록', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          const today = new Date()
          for (let i = 0; i < list.length; i++) {
            if (list[i].recruitStart != null && list[i].recruitEnd != null) {
              const start = new Date(list[i].recruitStart + ' 00:00:00:000')
              const end = new Date(list[i].recruitEnd + ' 23:59:59:999')
              let status = null
              if (today < start) {
                status = 'ready'
              } else if (today >= start && today <= end) {
                status = 'recruit'
              } else if (today > end) {
                status = 'done'
              }
              list[i].status = status
            }
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '프로그램 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
      })
    },
    addProgram () {
      this.$router.push({
        name: 'ProgramForm',
        params: {
          searchParams: this.searchParams
        }
      })
    },
    showProgram (item) {
      program.getProgram({
        programPid: item.programPid
      }, response => {
        console.log('프로그램 상세 정보', response)
        if (response.data.resultCode === 1) {
          this.$router.push({
            name: 'ProgramView',
            params: {
              searchParams: this.searchParams,
              data: response.data.result.body
            }
          })
        } else {
          common.amsAlert('retry', '프로그램 정보를 불러오지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
.mobile_wrap #programList {
  padding: 0 16px;
  box-sizing: border-box;
}

#programList .program_list_wrap .no_list_data {
  grid-column-end: 3;
  grid-row-end: 3;
}

.mobile_wrap #programList .program_list_wrap .no_list_data {
  grid-column-end: 2;
  grid-row-end: 4;
}
</style>



// WEBPACK FOOTER //
// src/components/program/List.vue